module.exports = function() {
  return new Worker(__webpack_public_path__ + "0315d6cd9549a8565148.worker.js");
};